import { RangePreset } from '@weave/schema-gen-ts/dist/schemas/reviews/v1/analytics/analytics.pb';
import { i18next } from '@frontend/i18n';
import { ReviewsPrefixes } from '@frontend/tracking-prefixes';

export const reviewServicesList = ['facebook', 'google', 'private', 'all-reviews'];

export const reviewAutoResponseFeatureFlag = 'reviews:create-auto-response';

export const TIME_RANGE_LABELS: Partial<{ [key in RangePreset]: string }> = {
  [RangePreset.ALL_TIME]: i18next.t('All Time', { ns: 'analytics' }),
  [RangePreset.TWELVE_MONTHS]: i18next.t('Last 365 Days', { ns: 'analytics' }),
  [RangePreset.THREE_MONTHS]: i18next.t('Last 90 Days', { ns: 'analytics' }),
  [RangePreset.THIRTY_DAYS]: i18next.t('Last 30 Days', { ns: 'analytics' }),
  [RangePreset.SEVEN_DAYS]: i18next.t('Last 7 Days', { ns: 'analytics' }),
  [RangePreset.RANGE_PRESET_UNSPECIFIED]: i18next.t('Custom', { ns: 'analytics' }),
};

export const TIME_RANGE_OPTIONS = [
  {
    value: RangePreset.ALL_TIME,
    label: TIME_RANGE_LABELS[RangePreset.ALL_TIME],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-all-time`,
  },
  {
    value: RangePreset.TWELVE_MONTHS,
    label: TIME_RANGE_LABELS[RangePreset.TWELVE_MONTHS],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-365-days`,
  },
  {
    value: RangePreset.THREE_MONTHS,
    label: TIME_RANGE_LABELS[RangePreset.THREE_MONTHS],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-90-days`,
  },
  {
    value: RangePreset.THIRTY_DAYS,
    label: TIME_RANGE_LABELS[RangePreset.THIRTY_DAYS],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-30-days`,
  },
  {
    value: RangePreset.SEVEN_DAYS,
    label: TIME_RANGE_LABELS[RangePreset.SEVEN_DAYS],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-7-days`,
  },
  {
    value: RangePreset.RANGE_PRESET_UNSPECIFIED,
    label: TIME_RANGE_LABELS[RangePreset.RANGE_PRESET_UNSPECIFIED],
    trackingId: `${ReviewsPrefixes.Analytics}-date-range-custom`,
  },
];
